export default __webpack_public_path__ + "static/media/oscer-pres-bone-pain.d28efc17.svg";